export default {
	nbTotalInterventions: 'Total missions',
	nbTotalAlertes: 'Total Alerts Detected',
	lastIntervention: 'Last mission',
	nextIntervention: 'Next mission',
	followedVehicule: 'Vehicle Follow-up Quality',
	pendingAlerts: 'Pending Alerts',
}
